import React, { useMemo } from "react";
import CompanyChart from "./CompanyChart";
import ItemChart from "./ItemChart";

function AssetChartContainer({ selectionId, currentUser }) {
  const isCompany = useMemo(() => {
    if (!selectionId) return false;

    const isTickerPattern = /^[A-Z]{1,5}$/.test(selectionId);
    const isBond = ["BND3", "BND7", "BND14"].includes(selectionId);

    return isTickerPattern || isBond;
  }, [selectionId]);

  if (!selectionId) {
    return (
      <div style={{ color: "#50e3c2", textAlign: "center", padding: "40px", fontSize: "0.6rem", fontFamily: "JetBrains Mono, monospace" }}>
        LOADING...
      </div>
    );
  }

  return isCompany ? (
    <CompanyChart tickerSelected={selectionId} currentUser={currentUser} />
  ) : (
    <ItemChart itemIdSelected={selectionId} currentUser={currentUser} />
  );
}

export default React.memo(AssetChartContainer);